import { render, staticRenderFns } from "./html-blocks.page.vue?vue&type=template&id=7cb3f2a2&scoped=true&"
import script from "./html-blocks.page.vue?vue&type=script&lang=js&"
export * from "./html-blocks.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb3f2a2",
  null
  
)

export default component.exports